<div class="edit-container">
	<h1 class="edit-title">Editare secțiune</h1>
	<form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="edit-field">
			<mat-form-field appearance="fill">
				<mat-label>Nume</mat-label>
				<input type="text" matInput formControlName="name" />
				<mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
					Camp obligatoriu
				</mat-error>
			</mat-form-field>
		</div>
		<div class="edit-field">
			<mat-form-field appearance="fill">
				<mat-label>Slug</mat-label>
				<input type="text" matInput formControlName="slug" />
				<mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
					Camp obligatoriu
				</mat-error>
			</mat-form-field>
		</div>
		<div class="edit-field">
			<mat-form-field appearance="fill">
				<mat-label>Observații</mat-label>
				<input type="text" matInput formControlName="observations" />
				<mat-error *ngIf="
            !form.controls['observations'].valid &&
            form.controls['observations'].touched
          ">
					Camp obligatoriu
				</mat-error>
			</mat-form-field>
		</div>

		<div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
		<div class="edit-action-btns">
			<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
				Close
			</button>
			<button class="buttons" type="submit" mat-flat-button color="primary">
				Save
			</button>
		</div>
	</form>
</div>